import { QueryKeys } from '../../../core/queries/query-keys.constants';
import { MANUAL_REFRESH_INTERVAL_MS } from '../dashboard.constants';
import { useThrottledInvalidateQueries } from '../../../hooks/use-throttled-invalidate-queries.hook';

/**
 * Returns a click handler that refreshes all dashboard stats. The stats queries are heavy,
 * so refreshes are rate-limited: the button stays clickable but only the first click per
 * interval triggers a refresh (leading throttle, no trailing so a rate-limited click
 * doesn't cause a surprise refetch later).
 */
export function useManualDashboardRefresh() {
  return useThrottledInvalidateQueries([QueryKeys.DASHBOARD], MANUAL_REFRESH_INTERVAL_MS, {
    leading: true,
    trailing: false
  });
}
